// extracted by mini-css-extract-plugin
export default {"container":"Book_container__6lP+Q","containerInfo":"Book_containerInfo__m3BQg","image":"Book_image__NI5ER","title":"Book_title__uSmAp","footerInfo":"Book_footerInfo__LdQ7H"};